import { ExecutiveDashboard, PerformancePage, BalancePage, IndicatorsPage } from "./finance-pages";
import { ReportsPage, PresentationsPage, StrategicMapsPage } from "./management-pages";
import { PreferencesPage, RealizadosPage, AdminPage } from "./settings-pages";
import { ApplicationsPage, DevelopmentMapPage } from "./utility-pages";
import { BudgetPage } from "./orcamento-page";

/** Route declarations consumed by the single Vite shell. Keep aliases so existing bookmarks stay valid. */
export const pageRoutes = [
  { paths: ["/", "/dashboard"], component: ExecutiveDashboard },
  { paths: ["/performance"], component: PerformancePage },
  { paths: ["/balanco"], component: BalancePage },
  { paths: ["/indicadores"], component: IndicatorsPage },
  { paths: ["/planejamento/orcamento"], component: BudgetPage },
  { paths: ["/relatorios"], component: ReportsPage },
  { paths: ["/apresentacoes"], component: PresentationsPage },
  { paths: ["/mapas-estrategicos"], component: StrategicMapsPage },
  { paths: ["/parametros/minhas-preferencias", "/minhas-preferencias"], component: PreferencesPage },
  { paths: ["/parametros/realizados", "/realizados"], component: RealizadosPage },
  { paths: ["/parametros/geral", "/geral", "/parametros"], component: AdminPage },
  { paths: ["/apps"], component: ApplicationsPage },
  { paths: ["/mapa"], component: DevelopmentMapPage },
];

export {
  ExecutiveDashboard,
  PerformancePage,
  BalancePage,
  IndicatorsPage,
  ReportsPage,
  PresentationsPage,
  StrategicMapsPage,
  PreferencesPage,
  RealizadosPage,
  AdminPage,
  ApplicationsPage,
  DevelopmentMapPage,
  BudgetPage,
};
